import { Injectable, signal, computed } from '@angular/core';
import { NavigationItem } from '../../models/navigation-item.interface';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly itemsSignal = signal<NavigationItem[]>([]);

  readonly items = computed(() => this.itemsSignal());

  setItems(items: NavigationItem[]): void {
    this.itemsSignal.set(items);
  }

  addItem(item: NavigationItem): void {
    this.itemsSignal.update((items) => [...items, item]);
  }

  removeItem(label: string): void {
    this.itemsSignal.update((items) =>
      items.filter((item) => item.label !== label),
    );
  }

  clearItems(): void {
    this.itemsSignal.set([]);
  }

  updateItem(label: string, updates: Partial<NavigationItem>): void {
    this.itemsSignal.update((items) =>
      items.map((item) =>
        item.label === label ? { ...item, ...updates } : item,
      ),
    );
  }

  setActiveItem(label: string): void {
    this.itemsSignal.update((items) =>
      items.map((item) => ({
        ...item,
        active: item.label === label,
      })),
    );
  }
}
